import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { Config, APIs_Config } from './sys_config/index';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HomepageComponent } from './homepage/homepage.component';
import { HeaderComponent } from './layouts/header/header.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { Request, Encryption } from './_service/index';
import { LocalstorageService } from '../app/sys_config/localstorage.service';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { PropDescPageComponent } from './prop-desc-page/prop-desc-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PropListingComponent } from './prop-listing/prop-listing.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LegalComponent } from './legal/legal.component';

@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    HeaderComponent,
    FooterComponent,
    ContactPageComponent,
    PropDescPageComponent,
    PropListingComponent,
    LegalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule

  ],
  providers: [
    Request,
    Encryption,
    Config,
    APIs_Config,
    LocalstorageService,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
